import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import PaymentMethodList from './PaymentMethodList';
import AddPaymentMethodModal from './AddPaymentMethodModal';
import { GenericModal } from '../../../../components/common/Modal/GenericModal';
import { showSuccessToast } from '../../../../components/PluginsMenu/Toastr/Toastr';
import { useDeletePaymentMethodMutation, useGetPaymentMethodsQuery, useSetDefaultMutation } from '../../../../../store/services/student/PaymentService';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe('pk_test_51R2U5YFRAm6imyzElLg2IuxyB1y52wFEGKrIbeJiYo5MrFJKGzh8GiYAHqCCq1qfS4GOILXxxHlSY84qFYpp7Zcj00LxuZH6Vz');

export const StudentPaymentMethod = () => {
  const { data, isLoading, isSuccess, refetch } = useGetPaymentMethodsQuery({PageNumber: 1, Take:10});
  const [deletePaymentMethod] = useDeletePaymentMethodMutation();
  const [setDefault] = useSetDefaultMutation();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Load payment methods from API
  useEffect(() => {
    if (isSuccess && data?.data) {
      const formatted = data.data.map(method => ({
        id: method.id,
        cardholderName: method.cardHolderName,
        last4: method.last4,
        type: method.type,
        expiryDate: method.expiryDate?.slice(0, 7), // Format as "YYYY-MM"
        isDefault: method.isDefault,
      }));
      setPaymentMethods(formatted);
    }
  }, [isSuccess, data]);

  const handleSetDefault = async (id) => {
    console.log("default id = ", id);
    try {
      const response = await setDefault({id});
      console.log("response default = ", response);
      if(response.data?.succeeded) {
        setPaymentMethods(prev =>
          prev.map(method => ({
            ...method,
            isDefault: method.id === id,
          }))
        );
        showSuccessToast('Default payment method updated!');
        await refetch();
      }
    } catch (error) {
      console.error('Error setting default payment method:', error);
    }
  };

  const showDeleteConfirmation = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      const response = await deletePaymentMethod({id: deleteId});
      console.log("delete = ", response);

      if(response.data?.succeeded) {
        setPaymentMethods(prev => prev.filter(method => method.id !== deleteId));
        showSuccessToast("Payment method deleted!");
        setShowDeleteModal(false);
        await refetch();
      }
    } catch (error) {
      console.error('Error deleting payment method:', error);
    }
  };

  const handleAddPaymentMethod = async (newPaymentMethod) => {
    const updated = newPaymentMethod.isDefault
      ? paymentMethods.map(m => ({ ...m, isDefault: false }))
      : [...paymentMethods];

    setPaymentMethods([
      ...updated,
      {
        ...newPaymentMethod,
        expiryDate: newPaymentMethod.expiryDate?.slice(0, 7),
      },
    ]);
    await refetch();
  };

  // Delete confirmation modal footer actions
  const deleteModalFooterActions = (
    <>
      <button className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
        Cancel
      </button>
      <button className="btn btn-danger" onClick={handleDelete}>
        Delete
      </button>
    </>
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          {isLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <PaymentMethodList
              paymentMethods={paymentMethods}
              onSetDefault={handleSetDefault}
              onDelete={showDeleteConfirmation}
            />
          )}

          <button
            onClick={() => setShowAddModal(true)}
            className="btn btn-primary d-flex align-items-center justify-content-center py-2"
          >
            <span style={{ marginRight: '8px' }}>+</span> Add New Payment Method
          </button>

          {/* Simple Delete Confirmation Modal */}
          <GenericModal
            show={showDeleteModal}
            handleClose={() => setShowDeleteModal(false)}
            title="Delete Payment Method"
            footerActions={deleteModalFooterActions}
          >
            <p>Are you sure you want to delete this payment method?</p>
            <p>This action cannot be undone.</p>
          </GenericModal>

          <Elements stripe={stripePromise}>
            <AddPaymentMethodModal
              show={showAddModal}
              handleClose={() => setShowAddModal(false)}
              onAddPaymentMethod={handleAddPaymentMethod}
            />
          </Elements>
        </div>
      </div>
    </div>
  );
};